import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/controls/Button';
import StatCard from '@/components/controls/StatCard';
import { useVoucherStatistics } from '@/hooks/useVoucherStatistics';

const CorporateDashboard: FC = () => {
  const navigate = useNavigate();
  const { statistics, isLoading } = useVoucherStatistics();

  const handlePurchaseVouchers = (): void => {
    navigate('/purchase-vouchers');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-primary-200" />
      </div>
    );
  }

  return (
    <div className="p-8">
      <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 mb-6">
        <div className="flex items-center space-x-3">
          <i className="pi pi-home text-primary-300 text-2xl" />
          <h1 className="text-3xl font-bold text-primary-300">Overview</h1>
        </div>
        <Button
          text="Purchase Vouchers"
          buttonStyle="bg-honoursOrange hover:bg-opacity-90 text-white px-12 py-2 rounded-[10px] font-medium w-full md:w-auto"
          buttonType={{ type: 'button' }}
          hasImage={false}
          onClick={handlePurchaseVouchers}
        />
      </div>

      <div className="mt-8 border rounded-[10px] p-6 bg-vouchersGray">
        <p className="text-sm text-white">
          As a corporate user you can purchase any number of vouchers for a Golf
          event, vouchers are only valid for the day of the event. <br />
          Vouchers can be generated into a PDF in the Voucher section for easy
          printing and distribution.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        <StatCard
          title="Purchased"
          count={statistics.purchased}
          variant="purchased"
        />
        <StatCard title="Active" count={statistics.active} variant="active" />
        <StatCard
          title="Redeemed"
          count={statistics.redeemed}
          variant="redeemed"
        />
      </div>
    </div>
  );
};

export default CorporateDashboard;
